<script>
import FormGroup from '@maison/components/form/FormGroup.vue';
import CheckboxField from '@maison/components/form/fields/CheckboxField.vue';
import ChinesePIPL from '@phoenix/mixins/components/form/fields/ChinesePIPL';

export default {
  components: {
    FormGroup,
    CheckboxField,
  },

  mixins: [ChinesePIPL],

  computed: {
    innerClass() {
      return this.customInnerClass || 'sgphx-w-full';
    },
    outerClass() {
      return this.customOuterClass || 'container sgphx-mt-base';
    },
  },
};
</script>

<template>
  <div :class="outerClass" data-cy="chinese-pipl-checkbox">
    <div :class="innerClass">
      <form-group
        v-for="checkbox in chinesePiplCheckboxes"
        :key="checkbox.id"
        :show-label="false"
        :attrs="checkbox"
        is-sgphx
      >
        <checkbox-field v-model="checkbox.value" is-sgphx />
      </form-group>
    </div>
  </div>
</template>
